import React, { useEffect, useContext, useState } from 'react';
import { useHistory } from "react-router-dom"
import lodash from 'lodash';
import { TournamentContext } from '../TournamentProvider'
import ManagementFooter from '../../ManagementFooter'
import { getCourse } from "../../../Database";
import Tournament011Container from './Tournament011Container'
import logo from "../../../images/logo.svg";
import { IconTournament } from "../../Icons";
import '../../../styles/styles.css';
import { } from '../../../Storage'
import { onSubmitCommon11_14 } from "../TournamentUtility";
import Loader from '../../Loader'
function Tournament_011(props) {
    const [value] = useContext(TournamentContext);
    const [tournament010Data] = useState(value.tournament010Data);                //グローバル参照渡し
    const [previewList, setPreviewList] = useState([undefined, undefined, undefined]);
    const history = useHistory();
    const [loadingData, setLoadingData] = useState(undefined);

    useEffect(() => {
        //一番上にスクロール
        window.scrollTo(0, 0);
        //ヘッダータイトル
        document.getElementById("header_title").innerText = value.header_title;
        //大会名
        document.getElementById("tournament_title").innerText = tournament010Data.title;
        //カテゴリー
        document.getElementById("ournament_category").innerText = tournament010Data.category;
        //開催する地域
        document.getElementById("ournament_area").innerText = tournament010Data.area;

        //開催日時と終了日時
        let eventDate = tournament010Data.eventDate.split("-");
        let eventStartTime = tournament010Data.eventStartTime.split("-");
        let eventFinishDate = tournament010Data.eventFinishDate.split("-");
        let eventFinishTime = tournament010Data.eventFinishTime.split("-");
        //開催日時と終了日時
        let tournament_open_close_date_time = eventDate[0] + "年" + eventDate[1] + "月" + eventDate[2] + "日" + eventStartTime[0] + "分~" +
            eventFinishDate[0] + "年" + eventFinishDate[1] + "月" + eventFinishDate[2] + "日" + eventFinishTime[0] + "分";

        document.getElementById("tournament_open_close_date_time").innerText = tournament_open_close_date_time;

        //最大エントリー数
        document.getElementById("tournament_max_entry").innerText = tournament010Data.max_entry;

        //利用するゴルフ場
        //データベースからコースデータの読み込み
        const getCourseData = (async () => {
            let loadCourse = await getCourse(tournament010Data.golfCourseDocId);
            document.getElementById("tournament_club").innerText = loadCourse.club_name;
            //ローディング非表示
            setLoadingData({ loadingFlg: false, title: "ゴルフ場データ読み込み中..." });
        });
        //ローディング表示
        setLoadingData({ loadingFlg: true, title: "ゴルフ場データ読み込み中..." });
        getCourseData();

        //１位
        document.getElementById("first_place").innerText = tournament010Data.first_place;
        //２位
        document.getElementById("second_place").innerText = tournament010Data.second_place;
        //３位
        document.getElementById("third_place").innerText = tournament010Data.third_place;
        //4日
        document.getElementById("fourth_place").innerText = tournament010Data.fourth_place;
        //5位
        document.getElementById("fifth_place").innerText = tournament010Data.fifth_place;
        //6位～10位
        document.getElementById("sixth_tenth").innerText = tournament010Data.sixth_tenth;
        //11位～60位
        document.getElementById("eleventh_sixtieth").innerText = tournament010Data.eleventh_sixtieth;
        //副賞
        document.getElementById("special_prize").innerText = tournament010Data.special_prize;
        //エントリー金額
        document.getElementById("entry_amount").innerText = tournament010Data.entry_amount;
        //グループの試合間隔
        document.getElementById("group_match_interval").innerText = tournament010Data.group_match_interval;

        //画像プレビュー
        setPreviewList([...tournament010Data.tournament_picture]);


    }, [tournament010Data.area, tournament010Data.category, tournament010Data.eleventh_sixtieth, tournament010Data.entry_amount, tournament010Data.eventDate, tournament010Data.eventFinishDate, tournament010Data.eventFinishTime, tournament010Data.eventStartTime, tournament010Data.fifth_place, tournament010Data.first_place, tournament010Data.fourth_place, tournament010Data.golfCourseDocId, tournament010Data.group_match_interval, tournament010Data.max_entry, tournament010Data.second_place, tournament010Data.sixth_tenth, tournament010Data.special_prize, tournament010Data.third_place, tournament010Data.title, tournament010Data.tournament_picture, value.header_title]);

    const onSubmit = (e) => {
        //これをやらないと同じページを呼ばれてしまう
        e.preventDefault();


        const asyncFunc = (async () => {

            let tournamentData = lodash.cloneDeep({ ...tournament010Data });
            let tournament_picture_file = lodash.cloneDeep(tournamentData.tournament_picture_file);


            onSubmitCommon11_14(document, tournamentData, tournament_picture_file, (result, status) => {
                //ローディング非表示
                setLoadingData({ loadingFlg: false, title: "大会データ変更中..." });

                if (result === false) {
                    alert("保存エラー=" + status);
                } else {
                    history.push("Tournament_012");
                }
            });
        });
        asyncFunc();
        //ローディング表示
        setLoadingData({ loadingFlg: true, title: "大会データ変更中..." });
    }


    const onClick = (e) => {

        switch (e.currentTarget.id) {
            case "button_back":
                history.push("/Tournament_010");
                break;
            default:
                break;
        }

    }
    const renderUseCourseList = () => {
        if (tournament010Data.useCourseList !== undefined) {
            return tournament010Data.useCourseList.map((data, i) =>
                <Tournament011Container key={data.key} courseData={data}>
                </Tournament011Container>)
        } else {
            return null;
        }
    }
    return (
        <div className="c-screen c-screen--gunmetal">
            {/*ローディング */}
            <Loader loadingData={loadingData}></Loader>
            <header className="c-container-vertical c-mt56">
                <div className="c-logo c-logo--144">
                    <img src={logo} alt="JCG Management" className="c-logo__source" />
                </div>
                <div className="kanri-title c-mt32">
                    <div className="kanri-title__icon">
                        <figure className="c-icon c-icon--white c-icon--32">
                            <IconTournament></IconTournament>
                        </figure>
                    </div>
                    <h1 className="c-heading--1" id="header_title">ツアー内容変更確認画面</h1>
                </div>
            </header>

            <main>

                <div className="c-page-section c-mt32">
                    <form onSubmit={onSubmit}>
                        <div className="kanri-container">

                            <div className="confirm confirm__vertical">
                                <span className="confirm confirm__label">大会タイトル</span>
                                <p className="confirm confirm__field" id="tournament_title" >第2回ツアー</p>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="confirm confirm__label">開催する大会のカテゴリ</span>
                                <p className="confirm confirm__field" id="ournament_category" >男子</p>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="confirm confirm__label">開催する地域</span>
                                <p className="confirm confirm__field" id="ournament_area" >関東</p>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="confirm confirm__label">開催日時と終了日時</span>
                                <p className="confirm confirm__field" id="tournament_open_close_date_time" >2021年6月13日10時~2021年6月14日19時</p>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="confirm confirm__label">最大エントリー数</span>
                                <p className="confirm confirm__field" id="tournament_max_entry" >20</p>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="confirm confirm__label">利用するゴルフ場</span>
                                <p className="confirm confirm__field" id="tournament_club" >大多喜カントリークラブ</p>
                            </div>

                            {/*<!-- コースを選択エリア -->*/}
                            <div className="c-container-vertical c-container-vertical--pale-spring-bud c-padding--24 c-radius--16 c-mt56">

                                <h2 className="c-heading--2 c-heading--left">利用コース</h2>
                                <p className="c-paragraph c-paragraph--left">利用するコースを選択してください。</p>
                                <div className="c-container-horizontal c-container-horizontal--space-around c-container-horizontal--wrap">
                                    {renderUseCourseList()}
                                </div>
                            </div>

                            <h2 className="c-heading--2 c-heading--left c-mt56">賞金金額、副賞</h2>

                            <div className="confirm confirm__vertical c-mt16">
                                <span className="input input__label">1位</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p id="first_place" className="confirm confirm__field confirm__field--extend">15万</p>
                                    <span className="input__suffix c-paragraph">円</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">2位</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p id="second_place" className="confirm confirm__field confirm__field--extend">10万</p>
                                    <span className="input__suffix c-paragraph">円</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">3位</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p id="third_place" className="confirm confirm__field confirm__field--extend">5万</p>
                                    <span className="input__suffix c-paragraph">円</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">4位</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p className="confirm confirm__field confirm__field--extend" id="fourth_place">1万</p>
                                    <span className="input__suffix c-paragraph">円</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">5位</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p className="confirm confirm__field confirm__field--extend" id="fifth_place">1万</p>
                                    <span className="input__suffix c-paragraph">円</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">6位&#12316;10位</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p className="confirm confirm__field confirm__field--extend" id="sixth_tenth">1万</p>
                                    <span className="input__suffix c-paragraph">円</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">11位&#12316;60位</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p className="confirm confirm__field confirm__field--extend" id="eleventh_sixtieth">1万</p>
                                    <span className="input__suffix c-paragraph">円</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">副賞</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p id="special_prize" className="confirm confirm__field confirm__field--extend">あきたこまち1年分</p>
                                    <span className="input__suffix c-paragraph">円</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">エントリー金額</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p id="entry_amount" className="confirm confirm__field confirm__field--extend">1万</p>
                                    <span className="input__suffix c-paragraph">　</span>
                                </div>
                            </div>

                            <div className="confirm confirm__vertical c-mt56">
                                <span className="input input__label">グループの試合間隔</span>
                                <div className="c-container-horizontal c-container-horizontal--center">
                                    <p id="group_match_interval" className="confirm confirm__field confirm__field--extend">5</p>
                                    <span className="input__suffix c-paragraph">分</span>
                                </div>
                            </div>

                            <h2 className="c-heading--2 c-heading--left c-mt56">メイン画像</h2>

                            <div className="c-container-vertical c-mt32">
                                <p className="c-paragraph c-paragraph--left">画像１</p>
                                <figure className="c-drag-and-drop__preview c-mt16">
                                    <img src={previewList[0]} id="tournament_picture_01" alt="" />
                                </figure>
                            </div>

                            <div className="c-container-vertical c-mt32">
                                <p className="c-paragraph c-paragraph--left">画像2</p>
                                <figure className="c-drag-and-drop__preview c-mt16">
                                    <img src={previewList[1]} id="tournament_picture_02" alt="" />
                                </figure>
                            </div>

                            <div className="c-container-vertical c-mt32">
                                <p className="c-paragraph c-paragraph--left">画像3</p>
                                <figure className="c-drag-and-drop__preview c-mt16">
                                    <img src={previewList[2]} id="tournament_picture_03" alt="" />
                                </figure>
                            </div>

                            <h2 className="c-heading--2 c-mt56">上記内容で作成します。よろしいですか?</h2>



                        </div>

                        <div className="c-button-set c-mt32 c-mb88">
                            <button id="button_next" className="button button__primary">変更する</button>
                            <button id="button_back" onClick={(e) => { onClick(e) }} className="button button__secondary">戻る</button>
                        </div>
                    </form>
                </div>

            </main>

            <footer>
                <ManagementFooter></ManagementFooter>
            </footer>



        </div>
    )
}



export default Tournament_011

